(() => {
  const root = document.querySelector('[data-fmobile]');
  if (!root) return;
  const menu = root.querySelector('[data-fmobile-menu]');
  const badge = root.querySelector('[data-fmobile-count]');
  const summary = menu.querySelector('summary');
  const close = () => { menu.open = false; summary.focus(); };
  root.querySelector('[data-fmobile-close]').addEventListener('click', close);
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && menu.open) close();
  });
  document.addEventListener('click', (event) => {
    if (menu.open && !root.contains(event.target)) menu.open = false;
  });
  root.querySelectorAll('a').forEach(link => link.addEventListener('click', () => { menu.open = false; }));
  const showCount = (count) => {
    if (!Number.isSafeInteger(count) || count < 0) return;
    badge.textContent = count > 99 ? '99+' : String(count);
    badge.setAttribute('aria-label', `カート ${count}点`);
    badge.hidden = count === 0;
  };
  let pending = false;
  let refreshAgain = false;
  const refresh = async () => {
    if (document.hidden) return;
    if (pending) { refreshAgain = true; return; }
    pending = true;
    try {
      const response = await fetch(root.dataset.cartUrl, {credentials:'same-origin', cache:'no-store', headers:{Accept:'application/json'}});
      if (response.ok) showCount((await response.json()).item_count);
    } catch (_) { /* Keep the server-rendered count when offline. */ }
    finally {
      pending = false;
      if (refreshAgain) { refreshAgain = false; refresh(); }
    }
  };
  window.addEventListener('pageshow', refresh);
  window.addEventListener('focus', refresh);
  document.addEventListener('visibilitychange', refresh);
  const catalogCount = document.querySelector('[data-cart-count]');
  if (catalogCount) new MutationObserver(refresh).observe(catalogCount,{childList:true,characterData:true,subtree:true});
})();
